module.exports = __webpack_public_path__ + "img/Sleeves-Front-B9-Da-Eb-Gb.69370ce0.png";